// extracted by mini-css-extract-plugin
export default {"childrenContainer":"SznjgX","iconContainer":"gg7naZ"};